import type { ReactNode } from 'react';

import { Typography } from '@arco-design/web-react';

import { ChangeDataCenter } from '@/components/TopNav/components/ChangeModule';
import { useDataCenterSwitcherPlacement } from '@/hooks/useTenantDataCenterSwitcher';

import styles from './index.module.less';

interface OverviewPageHeaderProps {
  /** 总览页标题。 */
  title: ReactNode;
  /** 标题下方的功能说明。 */
  description: ReactNode;
}

/** 统一总览标题与数据中心切换器的位置和样式。 */
export function OverviewPageHeader({ title, description }: OverviewPageHeaderProps) {
  const showDataCenterSwitcher = useDataCenterSwitcherPlacement() === 'page-banner';

  return (
    <div className={styles.header}>
      <div className={styles.titleRow}>
        <Typography.Title className={styles.title} heading={5}>
          {title}
        </Typography.Title>
        {showDataCenterSwitcher ? (
          <ChangeDataCenter
            style={{ width: 'auto', flex: '0 0 auto', height: 32, border: '1px solid var(--color-border-2, #e5e6eb)' }}
            refreshCurrentPage
          />
        ) : null}
      </div>
      <Typography.Text className={styles.description} type="secondary">
        {description}
      </Typography.Text>
    </div>
  );
}
